import { Alert, Button, Intent } from "@blueprintjs/core";

import PageContext from "../Context/PageContext";
import { useContext, useState } from "react";

import axios from "axios";
import { LoadTemplateJustModele } from "../Util/SaveUtil";
import SketchColor from "../Component/Card/SketchColor";
import Helper from "../Component/Helper";

export default function TemplateSection() {
    const { initModele, pageColor } = useContext(PageContext);

    const listTemplateSection = initModele.map((item: any) => {
        return <ItemTemplate item={item} key={item.id} />
    });

    return (
        <div>
            <h2> Style de l'affiche </h2>
            <div className="subtitle-section">
                <h3 > Fond de l'affiche </h3>
                <Helper text="Tu as la possibilité de personnaliser la couleur de fond de ton affiche" />
            </div>
            <div className="background-color-page">
                <div className="label-side-menu">
                    Couleur de fond
                    <img className="label-side-menu-img" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/proicons_background-color.svg"}></img>
                </div>
                <div className="background-color-page-picker">
                    <SketchColor elem={'page'} color={pageColor} />
                </div>
            </div>
            <div>
                <div className="subtitle-section">
                    <h3 > Modèle d'affiche </h3>
                    <Helper text="Nous avons conçu des affiches avec une variété de designs pour tous les goûts, et bien sûr, elles restent entièrement personnalisables​" />
                </div>

                <div className="modele-section-img">
                    {listTemplateSection}
                </div>
            </div>
        </div>

    );
}

function ItemTemplate(props: any) {
    const item = props.item;

    const { objItems, setObjItems,
        mapListPoint, setMapListPoint, addMapListPoint,
        mapListTrace, setMapListTrace,
        addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad,
        pageSize, setPageSize,
        pageColor, setPageColor,
        mapPosition, setMapPosition,
        mapTaille, setMapTaille,
        mapUrlStyle, setMapUrlStyle, setElevationData,
        setIsElevationPresent, setIsMode3D, setIsPortrait, setOpenAlertMsg, setMapLock, setSelectedItem,
        mapSources, mapLayers } = useContext(PageContext);

    const [isOpenAlert, setIsOpenAlert] = useState(false);

    var src = process.env.REACT_APP_URL_BACK + "/" + item.img;
    var json = process.env.REACT_APP_URL_BACK + "/" + item.file;

    function handleMoveCancel() {
        setIsOpenAlert(false)
    }

    function handleMoveConfirm(json: any) {
        setIsOpenAlert(false);
        if (setSelectedItem != null) setSelectedItem(null);

        importTemplate(json)
    }

    function openAlert(json: any, nom: string) {
        setIsOpenAlert(true)
    }

    function importTemplate(val: any) {

        axios(val)
            .then((res) => {
                LoadTemplateJustModele(res.data, {
                    setObjItems, mapListPoint, addMapListPoint, mapListTrace,
                    addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTraceSpecialFirtstLoad, setPageSize,
                    setPageColor, setMapPosition, setMapTaille, setMapUrlStyle, setElevationData, setIsElevationPresent,
                    setIsMode3D, setIsPortrait, setMapLock, mapSources, mapLayers
                }, false); //remettre false après
            })
            .catch(function (error) {
                if (setOpenAlertMsg != null) setOpenAlertMsg(true);
                console.log(error);
            });

    }

    return (
        <div className="template-item" key={item.id}>
            <Alert
                cancelButtonText="Retour"
                confirmButtonText="Let's go"
                icon="high-priority"
                intent={Intent.SUCCESS}
                isOpen={isOpenAlert}
                onCancel={handleMoveCancel}
                onConfirm={() => handleMoveConfirm(json)}
                canOutsideClickCancel={true}
                className="alert-modele"
            >
                <p>
                    Etes-vous sûr de vouloir charger le modèle <b>{item.name}</b> ? Vos modifications seront perdues, excepté votre itinéraire.
                </p>
            </Alert>
            <Button onClick={() => openAlert(json, item.nom)}><img title={item.name} className="modele-section-img-item" src={src} /></Button>
        </div >
    )

}